import{d as o}from"./chunk-57IQZAYS.js";import{a as r,c as g}from"./chunk-GENTI3H7.js";import{a as e,b as n,m as t}from"./chunk-HBP5N4FR.js";t();var p=()=>{let i=o(r),s=o(g);return n(e({},i),{isLoggedIn:s})};export{p as a};
//# sourceMappingURL=chunk-PLWMN4XQ.js.map
